"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useFocus = void 0;
var react_1 = __importDefault(require("react"));
var MarkChatReadBP = __importStar(require("@hiyllo/omni-common/src/blueprints/chat/mark-chat-read"));
function useFocus(chatUUID, 
/**
 * Whether the chat is currently active (i.e. the user is looking at it and scrolled to bottom)
 */
active, _a) {
    var seamlessClient = _a.seamlessClient;
    var activeRef = react_1["default"].useRef(active);
    var markChatReadMutation = seamlessClient.useStaticMutation(MarkChatReadBP);
    react_1["default"].useEffect(function () {
        activeRef.current = active;
        if (active) {
            void markChatReadMutation.call({ chatUUID: chatUUID });
        }
    }, [active]);
}
exports.useFocus = useFocus;
